var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveArchiveRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.66797H2.66671C1.93033 2.66797 1.33337 3.26492 1.33337 4.0013V4.66797C1.33337 5.40435 1.93033 6.0013 2.66671 6.0013H13.3334C14.0698 6.0013 14.6667 5.40435 14.6667 4.66797V4.0013C14.6667 3.26492 14.0698 2.66797 13.3334 2.66797Z",
    stroke: "#0F172A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66797V13.3346",
    stroke: "#0F172A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.668L8 8.66797L10 10.668",
    stroke: "#0F172A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 6V12C2.66663 12.3536 2.8071 12.6928 3.05715 12.9428C3.3072 13.1929 3.64634 13.3333 3.99996 13.3333H5.33329",
    stroke: "#0F172A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6V12C13.3333 12.3536 13.1928 12.6928 12.9428 12.9428C12.6927 13.1929 12.3536 13.3333 12 13.3333H10.6666",
    stroke: "#0F172A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveArchiveRestore);
export default __webpack_public_path__ + "static/media/active-archive-restore.82c413817c5fcaca9e27a15781055998.svg";
export { ForwardRef as ReactComponent };